export enum PaymentsActionType {
  SET_PAYMENTS = 'SET_PAYMENTS',
  SET_PAYMENTS_LOADING = 'SET_PAYMENTS_LOADING',
  RESET_PAYMENTS = 'RESET_PAYMENTS',
  SET_QUICK_DEPOSIT_OPEN = 'SET_QUICK_DEPOSIT_OPEN',
  SET_RATE_WITHDRAW = 'SET_RATE_WITHDRAW'
}
